import { Lightbulb, Minimize2, Settings } from 'lucide-react';
import React, { useRef } from 'react';
// import { Minimize2, Lightbulb, Settings } from 'lucide-react';

export default function RollerShades() {
  const whatWeOfferRef = useRef(null); // Reference for the "What We Offer" section
      
        const scrollToSection = () => {
          if (whatWeOfferRef.current) {
            whatWeOfferRef.current.scrollIntoView({ behavior: "smooth" });
          }
        };
  const gallery = [
    "images/rollerdesign.webp",
    "images/roller1.jpg",
    "images/rollerdesign1.webp",
    "images/roller2.jpg",
    "images/roller3.jpg",
    "images/rollerdesign2.webp",


  ];

  return (
    <div>
      {/* Hero Section */}
    

      {/* <section
        className="text-center font-anek object-cover h-screen bg-cover bg-center"
        style={{ backgroundImage: "url('images/roller.jpg')" }}
      >
  <div className="px-8 ">
          <h1 className="text-4xl text-left text-[#fff] font-Montserrat uppercase font-semibold mb-4 xl:text-9xl pl-4 sm:pl-16 lg:pl-60 pt-24 ">
          Roller
          </h1>

          <h1 className="text-4xl text-left font-Montserrat uppercase font-semibold mb-4 xl:text-9xl pr-4 pl-60  text-[#fff]">
          Shades
          </h1>
        </div>

        <div className=" mt-8 sm:mt-16 lg:mt-10 flex justify-start pl-[430px]">
          <button onClick={scrollToSection} className="text-white  bg-[#333232] text-xl w-60 px-6 py-3  ">
            LEARN MORE
          </button>
        </div>
      </section> */}

<section
  className="object-cover h-screen bg-cover bg-center flex flex-col pt-40 md:pt-40 items-center lg:items-start lg:text-left"
  style={{ backgroundImage: "url('images/roller.jpg')" }}
>
  <div className="px-8 sm:px-16 lg:px-24 text-center lg:text-left">
    <h1 className="text-5xl md:text-8xl 2xl:text-[130px] font-semibold text-white font-Montserrat uppercase mb-4">
      Roller
    </h1>
    <h1 className="text-5xl md:text-8xl 2xl:text-[130px] font-semibold text-white font-Montserrat uppercase mb-4">
      Shades
    </h1>
{/* Button positioned below the text */}
<div className="mt-4 lg:mt-6 flex justify-center ">
    <button
      onClick={scrollToSection}
      className="text-black bg-white 2xl:text-xl w-40 2xl:w-52 px-6 py-2"
    >
      LEARN MORE
    </button>
  </div>

  </div>
</section>


      {/* Features */}
      <section className="py-24 px-4 bg-white font-playfair">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-16">
            {[
              {
                icon: <Minimize2 className="w-10 h-10" />,
                title: "Clean Lines",
                description: "Sleek, modern design that complements any décor"
              },
              {
                icon: <Lightbulb className="w-10 h-10" />,
                title: "Light Control",
                description: "From sheer to blackout options for perfect ambiance"
              },
              {
                icon: <Settings className="w-10 h-10" />,
                title: "Smart Operation",
                description: "Motorized options with smart home integration"
              }
            ].map((feature, index) => (
              <div key={index} className="text-center">
                <div className="inline-block p-4 bg-blue-50 rounded-2xl mb-6">
                  <div className="text-blue-600">{feature.icon}</div>
                </div>
                <h3 className="text-2xl md:text-4xl font-bold mb-4">{feature.title}</h3>
                <p className="text-gray-600 md:text-xl">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="flex flex-col xl:gap-20 xl:px-20 2xl:px-40">
        {/* Header Section */}
        <header className="text-center pt-20">
          <h1 ref={whatWeOfferRef} className="text-4xl md:text-5xl lg:text-8xl font-extrabold text-gray-900 mb-8 ">Roller Shades</h1>
        </header>

        {/* About Roller Shades */}
        <section className="mb-16 px-3 flex  flex-col lg:flex-row gap-6 xl:gap-20 justify-between items-center">
          <h2 className="text-2xl md:text-6xl 2xl:text-8xl font-semibold text-gray-800  text-center">What are Roller Shades?</h2>
          <p className=" text-xl md:text-2xl xl:text-3xl 2xl:text-4xl text-gray-700 max-w-lg lg:max-w-lg xl:max-w-xl text-justify">
          Roller Shades are versatile window treatments that provide enhanced convenience, privacy,
          and energy efficiency. Designed to suit your needs, they offer a stylish and functional solution for any space.
          </p>
        </section>

        {/* Benefits of Roller Shades */}
        <section className="mb-16 px-3 flex flex-col lg:flex-row gap-10 md:gap-20 justify-between items-center">
          {/* < className=" text-xl text-gray-700"> */}
            <p className="text-xl md:text-2xl xl:text-3xl 2xl:text-4xl text-gray-700 max-w-lg lg:max-w-lg xl:max-w-xl text-justify">
            Roller Shades offer a simple and effective way to enhance privacy, control light, and improve energy efficiency. Easily adjust the blinds to suit your needs, providing
            comfort and style for any space. Perfect for maintaining privacy while allowing natural light to filter through
            </p>

          <h2 className="text-4xl md:text-6xl 2xl:text-8xl font-semibold text-gray-800 text-center">Benefits of Roller Shades</h2>

        </section>

        {/* How Roller Shades Work */}
        <section className="xl:mb-16 px-3 flex flex-col lg:flex-row gap-5 xl:gap-20 justify-between items-center">
          <h2 className="text-3xl md:text-6xl 2xl:text-8xl font-semibold text-gray-800 mb-4 text-center">How Do Roller Shades Work?</h2>
          <p className="text-xl md:text-2xl xl:text-3xl 2xl:text-4xl text-gray-700 max-w-lg lg:max-w-lg xl:max-w-xl text-justify ">
          Roller Shades are a practical solution for controlling light and privacy. Easily adjust the blinds to suit your needs, providing a smooth and quiet operation.
          Perfect for enhancing comfort and energy efficiency in any space, while maintaining a stylish and functional look
          </p>
        </section>
        </div>

      {/* Gallery */}
      <section ref={whatWeOfferRef} className="py-24 px-4 font-playfair bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-4xl md:text-7xl font-bold text-center mb-16">Shades Gallery</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {gallery.map((image, index) => (
              <div key={index} className="group relative aspect-[3/3] overflow-hidden rounded-xl">
                <img
                  src={image}
                  alt={`Roller shade inspiration ${index + 1}`}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute bottom-6 left-6">
                    <h3 className="text-white text-xl font-bold">Style {index + 1}</h3>
                    <p className="text-white/80 mt-2">Modern minimalism</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Technical Details */}
      <section className="py-24 px-4 font-playfair">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
            <div>
              <h2 className="text-4xl md:text-6xl font-bold mb-8 text-center">Technical Excellence</h2>
              <div className="space-y-6">
                <div className="p-6 bg-white rounded-xl shadow-lg">
                  <h3 className="text-xl md:text-3xl font-bold mb-2">Premium Materials</h3>
                  <p className="text-gray-600 md:text-xl">High-quality fabrics designed for durability and style</p>
                </div>
                <div className="p-6 bg-white rounded-xl shadow-lg">
                  <h3 className="text-xl font-bold mb-2 md:text-3xl">Precision Hardware</h3>
                  <p className="text-gray-600 md:text-xl">Smooth operation with premium components</p>
                </div>
                <div className="p-6 bg-white rounded-xl shadow-lg">
                  <h3 className="text-xl font-bold mb-2 md:text-3xl">Smart Integration</h3>
                  <p className="text-gray-600 md:text-xl">Compatible with leading smart home systems</p>
                </div>
              </div>
            </div>
            <div>
              <img
                src={gallery[4]}
                alt="Roller shade technical details"
                className="w-full rounded-2xl shadow-2xl"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}